// extracted by mini-css-extract-plugin
module.exports = {"list":"social-network_list__Qa2pS","item":"social-network_item__G72n1","icon":"social-network_icon___tNv_"};